var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.58 12.4999C15.58 14.4799 13.98 16.0799 12 16.0799C10.02 16.0799 8.42004 14.4799 8.42004 12.4999C8.42004 10.5199 10.02 8.91992 12 8.91992C13.98 8.91992 15.58 10.5199 15.58 12.4999Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.7702C15.53 20.7702 18.82 18.6902 21.11 15.0902C22.01 13.6802 22.01 11.3102 21.11 9.90021C18.82 6.30021 15.53 4.22021 12 4.22021C8.46997 4.22021 5.17997 6.30021 2.88997 9.90021C1.98997 11.3102 1.98997 13.6802 2.88997 15.0902C5.17997 18.6902 8.46997 20.7702 12 20.7702Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSvg);
export default __webpack_public_path__ + "static/media/eyeSvg.ae81c4ebbebc79b7f065c8cab1b79484.svg";
export { ForwardRef as ReactComponent };